// Derives up-to-two-letter initials from a name for avatar/logo fallbacks,
// e.g. "testhdueje workspace #1" -> "TW", "testhdueje" -> "T".
export const getInitials = (name: string): string => {
  return name
    .split(/\s+/)
    .filter(word => /[a-zA-Z0-9]/.test(word))
    .slice(0, 2)
    .map(word => word[0]?.toUpperCase() ?? '')
    .join('');
};
